import React, { Component, useState, useEffect } from 'react'
import '../styles/TargetCropSelection.css'
import DropdownWidget from '../widgets/DropdownWidget'
import InputTextFilterWidget from '../widgets/InputTextFilterWidget'
import OrgFooter from '../widgets/OrgFooter'
import AlertMessage from '../widgets/AlertMessage'
import DatePicker from '../widgets/DatePicker'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APIClusterRequest from '../api/APIClusterRequest'
import APIFarmerRequest from '../api/APIFarmerRequest'

class TargetCropSelection extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			user: JSON.parse(sessionStorage.getItem("user")),
			clusterId: sessionStorage.getItem("cluster-id"),
			targetCropId: props.targetCropId,
			itemObj: {},
			keyTracer: 0,
			cropItems: [],
			targetCrops: {},
			targetCropIds: [],
			cropStatus: "-- SELECT --",
			disabled: props.disabled,
			crops: JSON.parse(localStorage.getItem("crops")),
			measurements: JSON.parse(localStorage.getItem("measurements")),
			farmerInitial: {},
			clusterTargetCrop: {cluster_id: sessionStorage.getItem("cluster-id")}
		}
		this.eventHandler = this.eventHandler.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.getAllCrops = this.getAllCrops.bind(this)
		this.getAllTargetCropStatus = this.getAllTargetCropStatus.bind(this)
		this.getAllUnitsOfMeasurement = this.getAllUnitsOfMeasurement.bind(this)
		this.initiateListItem = this.initiateListItem.bind(this)
		this.addClusterTargetCrop = this.addClusterTargetCrop.bind(this)
		this.editClusterTargetCropById = this.editClusterTargetCropById.bind(this)
		this.deleteTargetCropById = this.deleteTargetCropById.bind(this)
		this.handleFooterEvent = this.handleFooterEvent.bind(this)
		this.getClusterById = this.getClusterById.bind(this)
		this.setTableValues = this.setTableValues.bind(this)
		this.getTargetCropById = this.getTargetCropById.bind(this)
		this.getAllTargetCropsByClusterId = this.getAllTargetCropsByClusterId.bind(this)
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		const initialCommitment = []
		const addInitialCommitment = []
		Object.values(this.state.farmerInitial).forEach((v) => {
			initialCommitment.push(v)
			if(v.init_commit_id) {
				initialCommitment.push(v)
			}
			else {
				addInitialCommitment.push(v)
			}
		})
		const data = {
			clusterTargetCrop: this.state.clusterTargetCrop,
		}
		if(initialCommitment.length > 0) {
			data['initialCommitment'] = initialCommitment
		}
		if(addInitialCommitment.length > 0) {
			data['add'] = {}
			data['add']['initialCommitment'] = addInitialCommitment
		}
		console.log("data", data)
		if(this.state.targetCropId == null) {
			this.addClusterTargetCrop(data)
		}
		else {
			this.editClusterTargetCropById(data)
		}
	}

	addClusterTargetCrop(targetCrop) {
		const apiReq = APIClusterRequest.addClusterTargetCrop(this.state.accessToken, targetCrop)
		apiReq.then((response) => {
			console.log('addClusterTargetCrop', response)
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					targetCrop: '',
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.error,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				submitAdd: false,
				showActivityIndicator: false,
				targetCrops: {}
			})
		})
	}

	editClusterTargetCropById(targetCrop) {
		const apiReq = APIClusterRequest.editClusterTargetCropById(this.state.accessToken, targetCrop, this.state.targetCropId)
		apiReq.then((response) => {
			console.log('editClusterTargetCropById', response)
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.error,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false,
				targetCrops: {}
			})
		})
	}

	deleteTargetCropById(id) {
		const apiReq = APIClusterRequest.deleteTargetCropById(this.state.accessToken, id)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				submitAdd: false,
				showActivityIndicator: false
			})
		})
	}

	componentWillMount() {
		this.getAllUnitsOfMeasurement()
		this.getAllTargetCropStatus()
		this.getAllTargetCropsByClusterId()
		if(this.state.targetCropId != null) {
			this.getTargetCropById()
		}
		else {
			this.getClusterById()
		}
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize.bind(this))
		this.setScrollable()
		this.setState({boardHeight: window.innerHeight * 0.5})
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize.bind(this))
	}

	getTargetCropById() {
		this.setState({showActivityIndicator: true})
		const cluster = APIClusterRequest.getTargetCropById(this.state.accessToken, this.state.targetCropId)
		cluster.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			const ics = {}
			for(const v of response.results.initialCommitment) {
				ics[v.registration_no] = v
			}
			this.getClusterById(ics)
			this.setState({
				initialDate: response.results.clusterTargetCrop.initial_commitment_date,
				targetCrop: response.results.clusterTargetCrop.crop,
				unit: response.results.clusterTargetCrop.unit_of_measurement,
				status: response.results.clusterTargetCrop.target_crop_status,
				showActivityIndicator: false
			})
		})
	}

	getClusterById(ics) {
		const cluster = APIClusterRequest.getClusterById(this.state.accessToken, this.state.clusterId)
		cluster.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			if(ics != null) {
				var members = Object.values(ics)
				for(const v of response.results.members) {
					if(ics.hasOwnProperty(v.registration_no)) {
						continue
					}
					members.push(v)
				}
				this.setTableValues(members, this.state.disabled)
			}
			else {
				this.setTableValues(response.results.members, this.state.disabled)
			}
			this.setState({
				members: (members != null)? members: response.results.members,
				showActivityIndicator: false
			})
		})
	}

	getAllTargetCropsByClusterId() {
		const clusters = APIClusterRequest.getAllTargetCropsByClusterId(this.state.accessToken, this.state.clusterId)
		clusters.then((response) => {
			console.log('getAllTargetCropsByClusterId', response)
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const cropIDs = []
			response.results.rows.map((item, i) => {
				cropIDs.push(item.crop_id)
			})
			this.setState({cropIDs: cropIDs})
		})
	}

	setTableValues(members, disabled) {
		const listItems = []
		for(const m of members) {
			// this.state.farmers[m.farmer_id] = {
			// 	init_commit_id: m.init_commit_id,
			// 	farmer_id: m.farmer_id,
			// 	area_planted: m.farmer_id,
			// 	initial_commitment:  m.initial_commitment
			// }
			listItems.push(<ListItem data={m} handler={this.eventHandler}
				disabled={disabled} key={Math.random()} />)
		}
		this.setState({listItems: listItems})
	}

	initiateListItem() {
		const cropItems = []
		const k = "ci-" + this.state.keyTracer
		this.state.itemObj[k] = <ListItem handler={this.eventHandler}
			isViewDetails={this.state.isViewDetails} key={k} id={k} />
		this.state.keyTracer++
		cropItems.push(this.state.itemObj[k])
		this.setState({cropItems: cropItems})
	}

	getAllCrops(callback) {
		const types = APIFarmerRequest.getAllCrops(this.state.accessToken)
		types.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.crop_id, name: v.name, key:v.crop_id})
			}
			localStorage.setItem("crops", JSON.stringify(c))
			callback()
		})
	}

	getAllTargetCropStatus(callback) {
		const types = APIClusterRequest.getAllTargetCropStatus(this.state.accessToken)
		types.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.target_crop_status_id, name: v.name})
			}
			this.setState({cropStatus: c})
		})
	}

	getAllUnitsOfMeasurement() {
		const units = APIClusterRequest.getAllUnitsOfMeasurement(this.state.accessToken)
		units.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.measurement_id, name: (v.name).toUpperCase()})
			}
			localStorage.setItem("measurements", JSON.stringify(c))
			this.setState({measurements: c})
		})
	}

	onResize() {
		this.setScrollable()
		this.setState({boardHeight: window.innerHeight * 0.5})
	}

	eventHandler(farmerId, value) {
		this.state.farmerInitial[farmerId] = value
	}

	setScrollable() {
		const sa = document.getElementById('tc-scroll-area')
		const ca = document.getElementById('tc-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+54) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	handleFooterEvent(e) {
		console.log('handleFooterEvent', e.value)
		if(e.value === "update") {
			this.setState({disabled: false})
			this.setTableValues(this.state.members, false)
		}
		else {
			this.props.handleFooterEvent(e)
		}
	}

	render() {
		const view = <div id="target-crop">
			<div id="tc-scroll-area"><div id="tc-client-area">
				<div className="title-bar">FOCUS CROP</div>
				<div id="tc-cell1">
					<div id="tc-cell1-i2">
						<div>Focus Crop</div>
						<InputTextFilterWidget list={this.state.crops} placeholder={this.state.targetCrop}
							onItemSelected={(id, val) => {
								console.log('cropIDs', this.state.cropIDs)
								if(this.state.cropIDs != null) {
									console.log(this.state.cropIDs.includes(parseInt(id)))
									if(this.state.cropIDs.includes(parseInt(id))) {
										console.log('cropIDs true')
										this.state.clusterTargetCrop["crop_id"] = undefined
										this.setState({isDuplicate: true})
										return
									}
								}
								this.state.clusterTargetCrop["crop_id"] = id
								this.setState({isDuplicate: false})
							}} cStyle={{"width": "100%"}} disabled={this.state.disabled} />
						{this.state.isDuplicate && <div style={{color: '#c96f6f'}}>* Duplicate focus crop not allowed</div>}
					</div>
					<div id="tc-cell1-i3">
						<div style={{'margin-bottom': '5px'}}>Unit of Measurement</div>
						<DropdownWidget list={this.state.measurements} placeholder={(this.state.unit != undefined)?this.state.unit:"-- SELECT --"}
						cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
							this.state.clusterTargetCrop["unit_of_measurement"] = val
						}} disabled={this.state.disabled} />
					</div>
				</div>
				<div className="title-bar">CLUSTER MEMBERS AREA PLANTED</div>
				<div id="tc-cell2">
					<div id="tc-table">
						<div className="tc-reg-no">Farmer Registration No.</div>
						<div className="tc-name">Cluster Member Name</div>
						<div className="tc-step2-area">Focus Crop's Area Planted (has)</div>
					</div>
					{this.state.listItems}
				</div>
			</div>
			{this.state.scrollable === true && <OrgFooter submit={this.onSubmit}
				eventHandler={this.handleFooterEvent}
				showCancel={!this.state.disabled}
				showSubmit={!this.state.disabled}
				showClose={this.state.disabled}
				showUpdate={(this.state.user.role_id == 3)? this.state.disabled: false} />}</div>
			{this.state.scrollable === false && <div className="alternate-footer">
				<OrgFooter submit={this.onSubmit}
				eventHandler={this.handleFooterEvent}
				showCancel={!this.state.disabled}
				showSubmit={!this.state.disabled}
				showClose={this.state.disabled}
				showUpdate={(this.state.user.role_id == 3)? this.state.disabled: false} /></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.props.handleFooterEvent("SUBMIT")
					this.setState({showInfoMessage: false})
			}} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class ListItem extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			isOn: false,
			initialCommitment: "0.0",
			supplyCommitment: "0",
			evaluatedSupply: "0",
			member: {},
			disabled: (props.disabled == null)? true: props.disabled
		}
	}

	componentWillMount() {
		if(this.props.data != null) {
			if(this.props.data.middle_name != null) {
				var mi = this.props.data.middle_name.charAt(0) + "."
			}
			const extn = (this.props.data.extension_name != null)? this.props.data.extension_name: ""
			const name = this.props.data.first_name + " " + mi + " " + this.props.data.last_name + " " + extn
			this.state.member["init_commit_id"] = this.props.data.init_commit_id
			this.state.member["farmer_id"] = this.props.data.farmer_id
			this.state.member["area_planted"] = this.props.data.area_planted
			this.setState({
				regNum: this.props.data.registration_no,
				name: name.toUpperCase(),
				farmerId: this.props.data.farmer_id,
				areaPlanted: (this.props.data.area_planted == null)? "": this.props.data.area_planted,
			})
		}
	}

	componentDidUpdate(prevProps) {
	}

	render() {
		const view = <div className="tc-listItem">
			<div className="tc-reg-no li-reg-no" disabled={this.state.disabled}>{this.state.regNum}</div>
			<div className="tc-name li-name" disabled={this.state.disabled}>{this.state.name}</div>
			<div className="tc-step2-area li-step2-area">
				<input type="text" value={this.state.areaPlanted} placeholder='0' onChange={(e) => {
					const checker = /^[\d,]+\.?\d{0,4}?$/
					const isValid = checker.test(e.target.value)
					if(isValid) {
						this.state.member["area_planted"] = parseFloat(e.target.value)
						this.props.handler(this.state.farmerId, this.state.member)
						this.setState({areaPlanted: e.target.value})
					}
					else {
						if(isNaN(parseInt(e.target.value))) {
							this.setState({areaPlanted: null})
							e.target.value = "";
						}
						else {
							e.target.value = parseInt(e.target.value);
						}
					}
				}} disabled={this.state.disabled} />
			</div>
		</div>
		return(view)
	}
}

export default TargetCropSelection
